import { TheoryApiAxiosBase } from '@/repository/base/axiosBase';
import { CreateActivityDto, FindActivitiesResponse } from '@/@types/activity';

export class ActivitiesRepository {
  private readonly requestBasePath = 'v1/activities'
  private readonly axios = new TheoryApiAxiosBase();

  async fetchActivitiesByProjectIds(projectIds: number[], organizationId: number) {
    const path = `${this.requestBasePath}/all`
    const data = { projectIds, organizationId };
    const response = await this.axios.post<FindActivitiesResponse>(path, data, { params: { 'project-id': projectIds[0] } });
    return response.data;
  }

  async createActivity(params: CreateActivityDto) {
    await this.axios.post(this.requestBasePath, params);
  }
}
